import { PUBLIC_REQUEST_KEY, API_PATH } from "../../constants/common.constant";
import fetch_ from "../../interceptors/FetchInterceptor";

const {
  GET_ESSAY,
  USERS_LIST,
  USERS_COUNT,
  BUSINESS_USERS_COUNT,
  USERS_REGISTER,
  BUSINESS_USER_REGISTER,
  BUSINESS_USERS_EDIT,
  BUSINESS_USERS_LIST_FILTER,
  USERS_UPDATE,
  USERS_DETAIL,
  USERS_DELETE,
  USERS_FORM_FIELDS,
  BUSINESS_USERS_LIST,
  ORDERS_LIST,
  ORDERS_COUNT,
  USER_SESSIONS,
  USER_SESSION_CHATS,
  USER_LOGIN_HISTORY,
  COUPONS_LIST,
  COUPON_CREATE,
  COUPON_DETAILS,
  COUPON_UPDATE,
  COUPON_DELETE,
  COUPON_STATS,
} = API_PATH;

export const UserService_ = {
  getUsers: (filter) => {
    return fetch_({
      url: USERS_LIST,
      method: "GET",
      params: filter,
    });
  },
  updateUser: (userId, user) => {
    return fetch_({
      url: USERS_UPDATE(userId),
      method: "PUT",
      data: user,
    });
  },
  getOrders: (filter) => {
    return fetch_({
      url: ORDERS_LIST,
      method: "GET",
      params: filter,
    });
  },
  getSessions: (userId, limit = 50) => {
    return fetch_({
      url: USER_SESSIONS(userId),
      method: "GET",
      params: { limit },
    });
  },
  getSessionChats: (userId, sessionId) => {
    return fetch_({
      url: USER_SESSION_CHATS(userId, sessionId),
      method: "GET",
    });
  },
  getLoginHistory: (userId, limit = 20) => {
    return fetch_({
      url: USER_LOGIN_HISTORY(userId),
      method: "GET",
      params: { limit },
    });
  },
  // Coupon Management Methods
  getAllCoupons: () => {
    return fetch_({
      url: COUPONS_LIST,
      method: "GET",
    });
  },
  createCoupon: (couponData) => {
    return fetch_({
      url: COUPON_CREATE,
      method: "POST",
      data: couponData,
    });
  },
  getCouponDetails: (couponId) => {
    return fetch_({
      url: COUPON_DETAILS(couponId),
      method: "GET",
    });
  },
  updateCoupon: (couponId, couponData) => {
    return fetch_({
      url: COUPON_UPDATE(couponId),
      method: "PATCH",
      data: couponData,
    });
  },
  deleteCoupon: (couponId) => {
    return fetch_({
      url: COUPON_DELETE(couponId),
      method: "DELETE",
    });
  },
  getCouponStats: (couponId) => {
    return fetch_({
      url: COUPON_STATS(couponId),
      method: "GET",
    });
  },
  // countOrders: (filter) => {
  //     return fetch_({
  //         url: ORDERS_COUNT,
  //         method: 'GET',
  //         params: filter
  //     })
  // }
  // getEssay: (filter) => {
  //     return fetch_({
  //         url: GET_ESSAY,
  //         method: 'POST',
  //         data: filter,
  //         headers: {
  //             [PUBLIC_REQUEST_KEY]: true
  //         },
  //     })
  // },
  // getBusinessUsersWithFilter: (filter) => {
  //     return fetch_({
  //         url: BUSINESS_USERS_LIST_FILTER,
  //         method: 'GET',
  //         params: filter
  //     })
  // },

  // getBusinessUsers: () => {
  //     return fetch_({
  //         url: BUSINESS_USERS_LIST,
  //         method: 'GET',
  //     })
  // },

  // getFormfields: (filter) => {
  //     return fetch_({
  //         url: USERS_FORM_FIELDS,
  //         method: 'GET',
  //         params: filter
  //     })
  // },
  // countUsers: (filter) => {
  //     return fetch_({
  //         url: USERS_COUNT,
  //         method: 'GET',
  //         params: filter
  //     })
  // },
  // countBusinessUsers: (filter) => {
  //     return fetch_({
  //         url: BUSINESS_USERS_COUNT,
  //         method: 'GET',
  //         params: filter
  //     })
  // },
  // getUser: userId => {
  //     return fetch_({
  //         url: USERS_DETAIL(userId),
  //         method: 'GET',
  //     })
  // },
  // addUser: user => {
  //     return fetch_({
  //         url: USERS_REGISTER,
  //         method: 'POST',
  //         data: user
  //     })
  // },

  // addBusinessUser: user => {
  //     return fetch_({
  //         url: BUSINESS_USER_REGISTER,
  //         method: 'POST',
  //         data: user
  //     })
  // },

  // updateBusinessUser: (userId, user) => {
  //     return fetch_({
  //         url: BUSINESS_USERS_EDIT(userId),
  //         method: 'PUT',
  //         data: user
  //     })
  // },
  // deleteUser: (userId) => {
  //     return fetch_({
  //         url: USERS_DELETE(userId),
  //         method: 'DELETE'
  //     })
  // },
};
